module.exports = __webpack_public_path__ + "static/media/performance-schedule.cacd7c78.svg";